import LineStoreIcon from 'LuxKit/Icons/line/LineStoreIcon'
import React, { useContext, useRef } from 'react'
import NavBarButton from '../NavBarButton/NavBarButton'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import ModalContext from 'contexts/ModalContext'
import Modal from 'LuxKit/Modal/Modal'
import DropdownSheet from 'LuxKit/Dropdown/Sheet/DropdownSheet'
import usePreferredRetailStore from 'hooks/usePreferredRetailStore'
import shouldRenderTimely, { getTimelyLink } from 'lib/timely/timely'
import GeoContext from 'contexts/geoContext'
import useToggle from 'hooks/useToggle'
import { useScreenSizeOnly } from 'hooks/useScreenSize'
import NavBarStoreDropdownContent from './NavBarStoreDropdownContent'
import { STORE_CAMPAIGN_URL } from 'constants/retailStores'

interface Props {
  className?: string
}

function NavBarStoreButton(props: Props) {
  const { className } = props
  const { currentRegionCode } = useContext(GeoContext)
  const preferredStore = usePreferredRetailStore()
  const { value: isDropdownOpen, toggle: toggleDropdown, off: closeDropdown } = useToggle()
  const buttonRef = useRef<HTMLButtonElement>(null)
  const isMobile = useScreenSizeOnly('mobile')
  const showModal = useContext(ModalContext)

  const handleClick = () => {
    if (!preferredStore) return

    if (isMobile) {
      showModal((resolve) => (
        <Modal
          title="Visit us in-store"
          actionsLayout="stacked"
          primaryActionText="Book free appointment"
          primaryActionHref={getTimelyLink()}
          primaryActionTarget="_blank"
          secondaryActionText="Learn more"
          secondaryActionTo={STORE_CAMPAIGN_URL}
          onSecondaryActionClick={resolve}
        >
          <NavBarStoreDropdownContent storeType={preferredStore} />
        </Modal>
      ))
    } else {
      toggleDropdown()
    }
  }

  if (!shouldRenderTimely(currentRegionCode) || !preferredStore) {
    return null
  }

  return (
    <>
      <NavBarButton
        className={className}
        icon={<LineStoreIcon />}
        onClick={handleClick}
        ref={buttonRef}
        size="small"
      >
        <CSSBreakpoint min="desktop">Visit us</CSSBreakpoint>
      </NavBarButton>
      <DropdownSheet
        size="S"
        open={!isMobile && isDropdownOpen}
        onClose={closeDropdown}
        anchorRef={buttonRef}
        triggerRef={buttonRef}
        title="Visit us in-store"
        hasDismissButton
        autoHeight
        noPaddingOnBody
        secondaryActionProps={{
          kind: 'tertiary',
          children: 'Learn more',
          to: STORE_CAMPAIGN_URL,
          onClick: closeDropdown,
        }}
        primaryActionProps={{
          children: 'Book free appointment',
          href: getTimelyLink(),
          target: '_blank',
          rel: 'noopener',
          onClick: closeDropdown,
        }}
      >
        <NavBarStoreDropdownContent storeType={preferredStore} />
      </DropdownSheet>
    </>
  )
}

export default React.memo(NavBarStoreButton)
